// src/pages/PhotosGallery.js 
// (Assuming this file contains your PhotosGallery component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import Footer from '../../CommonComponent/Footer/footer';
// NotificationBar was in the original useMeta import block but not in the return JSX, 
// so it is excluded from the imports for cleanliness.

// Page Component
import PGalleryGrid from './PageComponent/PGalleryGrid';


function PhotosGallery() {

  // The useMeta hook call is removed and its content is moved into <Helmet>
  return (
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>Our Gallery | Marvel Blinds</title>
        <meta
          name="description"
          content="Explore our stunning gallery showcasing memorable moments and vibrant images. Visit now to find inspiration for your next adventure!"
        />
        <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/photos-gallery/`} />

        {/* Open Graph Tags (for Social Media) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Our Gallery" />
        <meta
          property="og:description"
          content="Explore our stunning gallery showcasing memorable moments and vibrant images. Visit now to find inspiration for your next adventure!"
        />
        <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/photos-gallery/`} />
        <meta property="og:site_name" content="Marvel Blinds" />
      </Helmet>

      {/* Rest of your component structure */}
      <div>
        <Navbar />
        <PGalleryGrid />
        <Footer />
      </div>
    </>
  );
}

export default PhotosGallery;